import { DAPI_HOST } from '../../config';

export const getIsInMarketPlaceUrl = (latitude, longitude, market = 'DFW') =>
  `${DAPI_HOST}/v1/detect/is-in-market?` +
  `latitude=${latitude}&longitude=${longitude}&market=${market}`;
